import http from "@/http";

export default {
  login(objLogin) {
    return new Promise(function(resolve, reject) {
      http
        .post("User/Login", objLogin)
        .then(response => {
          if (response.data.authenticated) {
            sessionStorage.admin = JSON.stringify(response.data);
            resolve({ ok: true, token: response.data.accessToken });
          } else {
            resolve({ ok: false });
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  logout() {
    sessionStorage.clear("admin");
    window.location = "#/login";
  },
  getUser() {
    if (sessionStorage.admin != undefined && sessionStorage.admin != "") {
      return JSON.parse(sessionStorage.admin);
    } else {
      return false;
    }
  },
  isAdmin() {
    var user = this.getUser();

    if(user) {
      return user.info.permissionLevel === "Administrador";
    }
    
    return false;
  },
  isLoggedIn() {
    if (sessionStorage.admin === undefined) return false;
    let admin = JSON.parse(sessionStorage.admin);
    if (admin.token == "") return false;
    if (new Date() > new Date(admin.expiration)) return false;

    return true;
  },
  getHeaders(contentType) {
    return {
      headers: {
        Authorization: "Bearer " + this.getUser().accessToken,
        "Content-Type": contentType ? contentType : "application/json"
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/util/authentication.js